module.exports = __webpack_public_path__ + "summernote.75e7f4fb887aa2623e2e.ttf";


//////////////////
// WEBPACK FOOTER
// /app/vendor/summernote/font/summernote.ttf
// module id = ../../../../../vendor/summernote/font/summernote.ttf
// module chunks = styles